import GTM_ITEM_CATEGORIES from '../constants/gtmItemCategories';
import GTM_ITEM_XML_CATEGORIES from '../constants/gtmItemXmlCategories';

const convertAddonToGtmItem = ({
  brandName,
  basketDiscountCode,
  addon: { addon, price, quantity, day },
}) => ({
  // eslint-disable-next-line camelcase -- FIXME
  item_id: `${addon.id}`,
  // eslint-disable-next-line camelcase -- FIXME
  item_xml_id: `${GTM_ITEM_XML_CATEGORIES.addon}_${addon.id}`,
  // eslint-disable-next-line camelcase -- FIXME
  item_name: addon.name,
  coupon: basketDiscountCode,
  discount: price.discount,
  index: 0,
  // eslint-disable-next-line camelcase -- FIXME
  item_brand: brandName,
  // eslint-disable-next-line camelcase -- FIXME
  item_category: GTM_ITEM_CATEGORIES.addon,
  // eslint-disable-next-line camelcase -- FIXME
  item_category2: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category3: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category4: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category5: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category6: false,
  // eslint-disable-next-line camelcase -- FIXME
  item_category7: 0,
  // eslint-disable-next-line camelcase -- FIXME
  item_category8: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category9: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category10: day,
  // eslint-disable-next-line camelcase -- FIXME
  item_category11: day,
  // eslint-disable-next-line camelcase -- FIXME
  item_category12: '',
  price: addon.clientCost,
  quantity: Math.abs(quantity),
  duration: 1,
});

export default convertAddonToGtmItem;
